// eslint-disable-next-line import/prefer-default-export
export async function getAudioInputDevices(): Promise<MediaDeviceInfo[]> {
  const devices = await navigator.mediaDevices.enumerateDevices();
  return devices.map((device) => device.toJSON()).filter((device) => device.kind === 'audioinput');
}
